import React from 'react';

import PropTypes from 'prop-types';
import { Divider, Notification, Typography } from '@telus-uds/components-web';

const StatusBar = ({ status, setStatus }) => {
  return (
    <>
      <Notification
        variant={status.type === 'error' ? { validation: 'error' } : { style: 'success' }}
        dismissible
        onExit={() => setStatus({ isVisible: false, text: '' })}
        copy="en"
      >
        <Typography variant={{ bold: true }}>{status.text}</Typography>
      </Notification>
      <Divider space={3} variant={{ inverse: true }} />
    </>
  );
};

StatusBar.propTypes = {
  status: PropTypes.shape({
    isVisible: PropTypes.bool,
    text: PropTypes.string,
    type: PropTypes.string
  }).isRequired,
  setStatus: PropTypes.func.isRequired
};

export default StatusBar;
